export const newsletterSignupId = "newsletter"
